import api from "./client";

export interface Architecture {
  id: string;
  project_id: string;
  organization_id: string;
  name: string;
  description?: string;
  provider: "azure" | "aws" | "gcp" | "fabric";
  diagram_data: any;
  terraform_code?: string;
  estimated_cost?: number;
  is_favorite: boolean;
  version: number;
  last_generated_at?: string;
  created_at: string;
  updated_at: string;
}

export interface CreateArchitectureData {
  projectId: string;
  name: string;
  description?: string;
  provider: "azure" | "aws" | "gcp" | "fabric";
  diagramData?: any;
}

export interface UpdateArchitectureData {
  name?: string;
  description?: string;
  diagramData?: any;
  terraform_code?: string;
  estimated_cost?: number;
}

export async function getRecentArchitectures(): Promise<Architecture[]> {
  const response = await api.get("/api/architectures/recent");
  // L'API retourne { architectures: [...] }
  return response.data.architectures || response.data;
}

/** Récupère TOUTES les architectures de l'organisation (sans limite) via recent?limit=1000 */
export async function getAllArchitectures(): Promise<Architecture[]> {
  const response = await api.get("/api/architectures/recent?limit=1000");
  return response.data.architectures || response.data;
}

export async function getFavoriteArchitectures(): Promise<Architecture[]> {
  const response = await api.get("/api/architectures/favorites");
  // L'API retourne { architectures: [...] }
  return response.data.architectures || response.data;
}

export async function getArchitecturesByProject(projectId: string): Promise<Architecture[]> {
  const response = await api.get(`/api/architectures/project/${projectId}`);
  // L'API retourne { architectures: [...] }
  return response.data.architectures || response.data;
}

export async function getArchitecture(id: string): Promise<Architecture> {
  const response = await api.get(`/api/architectures/${id}`);
  // L'API retourne { architecture: {...} }
  return response.data.architecture || response.data;
}

export async function createArchitecture(data: CreateArchitectureData): Promise<Architecture> {
  const response = await api.post("/api/architectures", data);
  // L'API retourne { message: "...", architecture: {...} }
  return response.data.architecture || response.data;
}

export async function updateArchitecture(
  id: string,
  data: UpdateArchitectureData
): Promise<Architecture> {
  const response = await api.patch(`/api/architectures/${id}`, data);
  // L'API retourne { message: "...", architecture: {...} }
  return response.data.architecture || response.data;
}

export async function toggleFavorite(id: string): Promise<void> {
  await api.post(`/api/architectures/${id}/favorite`);
}

export async function duplicateArchitecture(id: string, name: string): Promise<Architecture> {
  const response = await api.post(`/api/architectures/${id}/duplicate`, { name });
  // L'API retourne { message: "...", architecture: {...} }
  return response.data.architecture || response.data;
}

export async function deleteArchitecture(id: string): Promise<void> {
  await api.delete(`/api/architectures/${id}`);
}

export async function renameArchitecture(id: string, name: string): Promise<Architecture> {
  const response = await api.patch(`/api/architectures/${id}`, { name });
  return response.data.architecture || response.data;
}

export async function updateArchitectureStatus(id: string, status: 'draft' | 'validated' | 'deployed'): Promise<Architecture> {
  const response = await api.patch(`/api/architectures/${id}`, { status });
  return response.data.architecture || response.data;
}
